import { render } from "./MulpumTypeV6.vue?vue&type=template&id=6474df49&scoped=true"
import script from "./MulpumTypeV6.vue?vue&type=script&lang=js"
export * from "./MulpumTypeV6.vue?vue&type=script&lang=js"

import "./MulpumTypeV6.vue?vue&type=style&index=0&id=6474df49&scoped=true&lang=css"
import "./MulpumTypeV6.vue?vue&type=style&index=1&id=6474df49&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6474df49"]])

export default __exports__